import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { ALLOWED_MIME_TYPES, ALLOWED_TEXTURE_FILE_TYPES } from '../../constants/constants';
import { checkImageTypes, removeExifFromMultipleFiles } from '../../helpers/jsHelper';
import icons from '../../assets';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: 150,
  padding: '20px',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',

  background: '#F9F9F9',
  border: '2px dashed #A3A4A6',
  borderRadius: '16px',
};

const acceptStyle = {
  border: '2px dashed #0059F1',
};

const rejectStyle = {
  border: '2px dashed #ff1744',
};

const { FileFolder } = icons;

const MyDropzone = (props) => {
  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
    accept: props?.isXlsx
      ? 'image/png, image/jpg, image/jpeg, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv'
      : props?.accept || 'image/png, image/jpg, image/jpeg',
    // accept: props?.isXlsx ? 'image/png, image/jpg, image/jpeg, .xlsx, .xls' : 'image/png, image/jpg, image/jpeg',
    // accept: 'image/png, image/jpg, image/jpeg, .xlsx, .xls',
    onDrop: async (acceptedFiles) => {
      acceptedFiles = await removeExifFromMultipleFiles(acceptedFiles);
      if (props?.accept) {
        props.onDrop(acceptedFiles);
      } else {
        if (
          !props?.isXlsx &&
          checkImageTypes(acceptedFiles, ALLOWED_MIME_TYPES, 'Only jpg/png images are allowed')
        ) {
          props.onDrop(acceptedFiles);
        }
        if (
          props?.isXlsx &&
          checkImageTypes(
            acceptedFiles,
            ALLOWED_TEXTURE_FILE_TYPES,
            'Only jpg/png, .xlsx, .xls or .csv files are allowed'
          )
        ) {
          props.onDrop(acceptedFiles);
        }
      }
    },
    multiple: !props?.restrictMultiple,
  });

  const style = useMemo(
    () => ({
      ...(!props?.noInlineStyle ? baseStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
      ...(props?.style || {}),
    }),
    [isDragAccept, isDragReject, isFocused]
  );

  return (
    <>
      {props.v2UploadTextures ? (
        <div className="dropzone" {...getRootProps({ style })}>
          <input {...getInputProps()} />
          {props?.children || (
            <>
              <FileFolder />
              <p className="dz-title">
                <span>Choose {props?.isSingleAllowed ? "file" : "files"}</span> or drag {props?.isSingleAllowed ? "it" : "them"} here
              </p>
              <p className="dz-sub-title small mb-0">{props.subTitle}</p>
            </>
          )}
        </div>
      ) : (
        <div className="dropzone" {...getRootProps({ style })}>
          <input {...getInputProps()} />
          {props?.children || (
            <>
              <p className="dz-title">{props.title || 'Select file'}</p>
              <p className="dz-sub-title">{props.subTitle || 'or drop file here'}</p>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default MyDropzone;
